import numeral from 'numeral';

export const format = (field: any, translate: Function = () => { return ''; }) => {
  let value: string = '';
  if (field && field.fieldValue !== undefined && field.fieldValue !== null) {
    value = (field.fieldValue).toString();
    if(field.fieldName === 'deal_no') {
      value = field.fieldValue.substring(0, 11) + ' ' + field.fieldValue.substring(11,field.fieldValue.length);
    }
    if(field.fieldType === 'no-data') {
      value = translate(field.fieldValue);
    }
    if (field.fieldType === 'number') {
      value = numeral(field.fieldValue).format('0,0');
    } else if (field.fieldType === 'currency') {
      value = numeral(field.fieldValue).format('0,0.00');
      if (field.customAttributes) {
        value = `${field.customAttributes.currency}${value}`;
      }
    }
  }
  if(field && field.fieldValue !== undefined && field.fieldValue !== null && field.fieldValue === -1) {
    value = '';
  }

  return value;
}
